import React, { useCallback } from "react";
import * as styles from "./pin-gateway.module.scss";
import {
	PinGatewayState,
	PinGatewayStep,
} from "../../../../state/pin-gateway-state";
import PinGatewayWarning from "./pin-gateway-warning";
import PinGatewayPositioning from "./pin-gateway-positioning";

export interface PinGatewayProps {
	state: PinGatewayState;
}

export default function PinGateway(props: PinGatewayProps) {
	const propsSetSelection = props.state.setSelection;
	const propsSetStep = props.state.setStep;

	const close = useCallback(() => {
		propsSetSelection(null);
	}, [propsSetSelection]);

	const setStepPosition = useCallback(() => {
		propsSetStep(PinGatewayStep.Position);
	}, [propsSetStep]);

	if (props.state.selection === null) {
		return null;
	}

	if (props.state.step === PinGatewayStep.Warning) {
		return <PinGatewayWarning onNext={setStepPosition} onClose={close} />;
	} else {
		return (
			<PinGatewayPositioning
				deviceID={props.state.selection.id}
				deviceModel={props.state.selection.model}
				onClose={close}
				onNext={props.state.submit}
				disableNext={props.state.location === null}
				isLoading={props.state.loading}
			/>
		);
	}
}
